// Externe Bibliotheken
import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';

// Interne Module
import * as storage from '@/_helper/storage';
import { convertDate, convertPrice, createPaxAges } from '@/_helper/mapper';
import tracking from '@/_helper/tracking';

// Komponenten
import LoadingOffersBar from '@/comp/loadingOffersBar';
import { BackButton } from '@/comp/backButton/backButton';
import Button from '@/comp/button/button';

const params = {
    errorWording: {
        transferOffer: 'Bitte wählen Sie eine Option aus.',
        accept: 'Bitte bestätigen Sie, dass Sie die Informationen aus der AGB, Vorab-Informationen zum Datenschutz und Datenschutzhinweise des Reiseveranstalters AurumTours zur Kenntnis genommen haben!',
    },
};

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 0,
            data: [],
            accept: false,
            isLoading: false,
            hasResult: false,
            transferOfferValid: false,
            formErrors: {
                transferOffer: '',
                accept: '',
            },
            error: null,
            formValid: false,
            formVacancy: false,
        };

        this.handleCheckClicked = this.handleCheckClicked.bind(this);

        this.handleUserInput = this.handleUserInput.bind(this);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        let offers = storage.get('transferOffers');

        // remove old offers
        if (offers !== null && offers.data !== undefined && offers.data.travelType !== 'transfer') {
            storage.remove('transferOffers');
        } else if (offers !== null && offers.data !== undefined) {
            this.setState({
                data: offers.data,
                isLoading: false,
            });

            return false;
        }

        // loading state
        this.setState({ isLoading: true });

        let bookingData = storage.get('bookingData');
        let searchParams = undefined;
        let hotelSupplier = '';
        let handlingSupplier = '';
        if (bookingData !== null) {
            searchParams = bookingData.data.searchParams;
            // hotel supplier from serviceInformation.hotel.supplier, if exists
            if (bookingData.data.serviceInformation.hotel !== undefined) {
                if (bookingData.data.serviceInformation.hotel.supplier !== undefined) {
                    hotelSupplier = bookingData.data.serviceInformation.hotel.supplier;
                }
            }

            // handling supplier from serviceInformation.handling.supplier, if exists
            if (bookingData.data.serviceInformation.handling !== undefined) {
                if (bookingData.data.serviceInformation.handling.supplier !== undefined) {
                    handlingSupplier = bookingData.data.serviceInformation.handling.supplier;
                }
            }
        }

        if (searchParams !== undefined && searchParams.adults > 0) {
            const sendData = {
                requestType: 'searchExtra',
                travelType: 'transfer',
                regionCode: searchParams.destination,
                arrivalAirportCode: searchParams.retAirport,
                travelStart: convertDate(searchParams.depDate),
                travelEnd: convertDate(searchParams.retDate),
                paxAges: createPaxAges(searchParams.paxAges),
                hotelCodeList: [searchParams.hotelCode],
                filterTags: [],
                departureTime: searchParams.transferDepartureTime,
                returnTime: searchParams.transferArrivalTime,
                amountAdults: searchParams.adults,
                clientId: 'customerarea',
                hotelSupplier: hotelSupplier,
                handlingSupplier: handlingSupplier,
            };

            axios({
                url: window.$requestUrl + '/searchExtra?token=' + window.$token,
                method: 'POST',
                data: JSON.stringify(sendData),
            })
                .then((response) => response)
                .then((data) => {
                    this.setState({
                        data: data.data.data,
                        hasResult: true,
                    });

                    storage.set('transferOffers', {
                        data: data.data.data,
                    });
                })
                .catch((error) => this.setState({ error, isLoading: false }));
        }
    }

    image(tariffCode) {
        let icon = 'airport_shuttle';

        switch (tariffCode) {
            case (tariffCode = 'taxi'):
                icon = 'directions_car';
                break;
            default:
        }

        return (
            <div className="image">
                <i className="material-symbols-outlined">{icon}</i>
            </div>
        );
    }

    description(tariffCode) {
        let getTransferMapper = window.$content.mappingTransfer;

        if (getTransferMapper[tariffCode] !== undefined && getTransferMapper[tariffCode].description !== undefined) {
            return (
                <div className="description">
                    <p>{getTransferMapper[tariffCode].description}</p>
                </div>
            );
        }
    }

    maxLength(e) {
        let length = 40;

        if (e.length > length) {
            return e.substring(0, length) + '...';
        } else {
            return e;
        }
    }

    handleUserInput(event) {
        const target = event.target;
        let value = target.value;
        const name = target.name;

        // if ( target.checked ) {
        value = target.checked !== true ? false : true;
        // }

        this.setState({ [name]: target.value }, () => {
            this.validateField(name, value);
        });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let transferOfferValid = this.state.transferOfferValid;

        switch (fieldName) {
            case 'transferOffer':
                transferOfferValid = value === true;
                fieldValidationErrors.transferOffer = transferOfferValid ? '' : params.errorWording.transferOffer;
                break;
            default:
                break;
        }
        this.setState({ formErrors: fieldValidationErrors, transferOfferValid: transferOfferValid }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.transferOfferValid });
    }

    handleCheckClicked(e) {
        this.setState({
            [e.target.name]: e.target.checked,
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        // form validation
        if (!this.state.formValid) {
            // form is invalid! so we do nothing

            // set error dialogs
            let fieldValidationErrors = this.state.formErrors;
            fieldValidationErrors.accept = params.errorWording.accept;
            fieldValidationErrors.transferOffer = params.errorWording.transferOffer;

            this.setState({
                formErrors: fieldValidationErrors,
            });

            return;
        }
        // form is valid!
        let offerId = this.state.transferOffer;

        // Vacancy
        const sendVacancyData = {
            travelType: 'transfer',
            vacancyType: 'transfer',
            responseDetailLevel: 'full',
            ignoreCache: true,
            vacancyBeforeBooking: true,
            requestType: 'vacancy',
            clientId: 'customerarea',
            transferOfferKey: this.state.transferOffer,
            processToken: this.state.data.processToken,
        };

        if (Object.keys(this.state.data.handlingOffers).length > 0 && this.state.data.handlingOffers !== undefined) {
            _.assign(sendVacancyData, {
                handlingOfferKey: this.state.transferOffer + '-HDL',
            });
        }

        this.setState({
            formVacancy: true,
        });

        axios({
            url: window.$requestUrl + '/vacancy?token=' + window.$token,
            method: 'POST',
            data: JSON.stringify(sendVacancyData),
        })
            .then((response) => response)
            .then(function (response) {
                let bookStates = {
                    travelType: 'transfer',
                    vacancyToken: response.data.data.requestToken,
                    processToken: response.data.data.processToken,
                    offerId: offerId,
                    vacancyData: response.data.data.transferOffer,
                };

                sessionStorage.setItem('bookStates', JSON.stringify(bookStates));

                window.location.href = `#/buchung/${window.$content.extras['transfer'].link}`;
            })
            .catch((error) => this.setState({ error, formVacancy: false }));
    }

    render() {
        const { isLoading, error, hasResult } = this.state;

        if (error || this.state.data === undefined) {
            return (
                <div>
                    <div className="error">Leider sind keine Transferangebote zu Ihren Buchungsdaten verfügbar.</div>
                    <div className="user-action">
                        <BackButton class="col" target="blank" />
                    </div>
                </div>
            );
        }

        if (isLoading) {
            if (hasResult) {
                setTimeout(() => {
                    this.setState({
                        isLoading: false,
                    });
                }, 2000);
            }
            return <LoadingOffersBar hasResult={hasResult} />;
        }

        // generate tabs
        const entries = [];
        const $offers = [];

        if (this.state.data && this.state.data.transferOffers !== undefined) {
            let $transferOffers = this.state.data.transferOffers;

            let $handlingOffers;
            if (this.state.data.handlingOffers !== undefined) {
                $handlingOffers = this.state.data.handlingOffers;
            }

            if ($transferOffers.length === 0) {
                return (
                    <div>
                        <div className="error">
                            Leider sind keine Transferangebote zu Ihren Buchungsdaten verfügbar.
                        </div>
                        <div className="user-action">
                            <BackButton class="col" target="blank" />
                        </div>
                    </div>
                );
            }

            // sort by price : asc
            // $transferOffers = _.orderBy($transferOffers, ['price.overallGrossPrice'],
            // ['asc']);

            Object.keys($transferOffers).forEach((k) => {
                let transferOffer = $transferOffers[k];
                let offerKey = transferOffer.offerKey;
                let handlingOfferKey = '';
                let overallPrice = transferOffer.price.overallGrossPrice;
                let tariffCode = transferOffer.tariffCode;

                let handlingOffer = $handlingOffers[offerKey + '-HDL'];
                if (handlingOffer !== null && handlingOffer !== undefined) {
                    overallPrice = overallPrice + handlingOffer.price.overallGrossPrice;
                    handlingOfferKey = handlingOffer.offerKey;
                }
                $offers.push(
                    <div key={k} className="case">
                        <input
                            id={handlingOfferKey}
                            type="radio"
                            name={'handlingOffer'}
                            value={handlingOfferKey}
                            onChange={(event) => this.handleUserInput(event)}
                        />
                        <input
                            id={k}
                            type="radio"
                            name={'transferOffer'}
                            value={k}
                            onChange={(event) => this.handleUserInput(event)}
                        />
                        <div className="icon"></div>
                        <label htmlFor={k}>
                            {this.image(tariffCode.toLowerCase())}

                            <div className="inline-content">
                                <div className="cnt">
                                    <h3 className="title">
                                        {window.$content.mappingTransfer[tariffCode.toLowerCase()] !== undefined &&
                                        window.$content.mappingTransfer[tariffCode.toLowerCase()].heading !== undefined
                                            ? window.$content.mappingTransfer[tariffCode.toLowerCase()].heading
                                            : tariffCode.charAt(0).toUpperCase() +
                                              tariffCode.toLowerCase().slice(1).replace('_', '-')}
                                    </h3>

                                    {this.description(tariffCode.toLowerCase())}
                                </div>
                                <div className="price-sec">
                                    <small>Gesamtpreis</small>
                                    <div className="overall-price">
                                        {overallPrice >= 0 ? '+' : '-'} {convertPrice(overallPrice, 0, 0)}
                                    </div>
                                </div>
                            </div>
                        </label>
                    </div>
                );
            });

            entries.push(
                <div className="entry" key="">
                    <div className="offers">
                        {$offers}

                        {this.state.transferOfferValid === false && this.state.formErrors.transferOffer.length > 0 && (
                            <div className="error">{this.state.formErrors.transferOffer}</div>
                        )}
                    </div>

                    <div className="user-action">
                        <BackButton class="col" target="blank" />

                        <Button
                            valid={this.state.formValid}
                            validated={this.state.formVacancy}
                            type="submit"
                            label={this.state.formVacancy ? 'Daten werden übermittelt ...' : `Weiter zur Übersicht`}
                            icon="arrow_forward"
                        />
                    </div>
                </div>
            );
        }

        return (
            <form
                className={'txtL ' + (this.state.formVacancy ? 'validate' : '')}
                autoComplete="off"
                onSubmit={this.handleSubmit}
                method="post"
                noValidate=""
                onChange={() => tracking('interaction', 'transfer')}>
                <p className="text-max-width">
                    Wählen Sie jetzt ein passendes <b>Transferangebot</b> aus!
                </p>
                {entries}
            </form>
        );
    }
}

export default Form;
